module.exports = new Promise((resolve, reject) => {
      const url = window.__REMOTES__?.["commons"] || "http://localhost:8900/remoteEntry.js";
      const script = document.createElement("script");
      script.src = url;
      script.onload = () => resolve(window["commons"]);
      script.onerror = (e) => reject(new Error("Failed to load remote: commons from " + url));
      document.head.appendChild(script);
    });